module.exports = __webpack_public_path__ + "img/bitget_futures-logo.7f99feb5.png";